import {
  asyncActionFinish,
  asyncActionError,
} from '../../../App/common/reduxs/async/asyncActions';
import { profilGet, profilUpdate } from './reduxAction';
import { mainPhotoUpdate } from '../../../App/login/redux/authAction';
import { ASYNC_ACTION_START } from '../../../App/common/reduxs/async/asyncConstant';
import { SITE_ADDRESS } from '../../../App/common/data/siteConfig';
import { checkRes, checkErr } from '../../../App/common/helpers/checkRes';
import { authUpdate } from '../../../App/login/redux/authAction';

export const getProfil = (auth, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getProfil' });
    const vusn = auth?.vusn;
    const userId = auth?.userId;
    const username = auth?.username;
    const sessionId = auth?.sessionId ?? '';
    const deviceId = auth?.deviceId ?? '';
    const activeJenjang = auth?.active_jenjang ?? '';
    const activeKelas = auth?.active_kelas ?? '';
    const activeYear = auth?.active_year ?? '';
    const activeSem = auth?.active_sem ?? '';
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('username', username);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('activeJenjang', activeJenjang);
    formData.append('activeKelas', activeKelas);
    formData.append('activeYear', activeYear);
    formData.append('activeSem', activeSem);
    formData.append('role', auth?.role);
    try {
      let fetchData = await fetch(SITE_ADDRESS + 'profil/', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const res = await fetchData.json();
      const resultCheck = checkRes(res, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }

      let profil = res.profil;
      let studentHistory = res.history;
      let jenjangs = res.jenjangs;
      let kelass = res.kelass;
      let years = res.years;
      let sems = res.sems;
      let urlPhoto = res.urlPhoto;

      dispatch(
        profilGet({ profil, history: studentHistory, jenjangs, kelass, years, sems })
      );
      dispatch(authUpdate({ mainPhoto: urlPhoto }));
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const photoUpload = ({ image, filename, authData, history }) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'photoUpload' });
    const sessionId = authData.sessionId;
    const userId = authData.userId;
    const username = authData.username;
    const formData = new FormData();
    formData.append('sessionId', sessionId);
    formData.append('userId', userId);
    formData.append('username', username.toLowerCase().split(' ').join('_'));
    formData.append('image', image);
    formData.append('filename', filename);
    try {
      let fetchData = await fetch(
        SITE_ADDRESS + 'profil/upload-photo/' + userId,
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + authData.token,
          },
        }
      );
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }
      const urlPhoto = response.urlPhoto;
      dispatch(
        profilUpdate({
          urlPhoto: urlPhoto,
        })
      );
      dispatch(mainPhotoUpdate({ mainPhoto: urlPhoto }));
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};
